import { render, staticRenderFns } from "./PhysicianView.vue?vue&type=template&id=62aa2060&"
import script from "./PhysicianView.vue?vue&type=script&lang=js&"
export * from "./PhysicianView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports